let elementsForm,contLogin = 1;

function validationForm(elementsForm,contLogin)
{
  for(let i=0;i<elementsForm.length;i++){
    if ( $.trim($("#"+elementsForm[i]).val()) == "" ) {
      contLogin = 0;
    }
  }
  return contLogin;
}

$('.btnFormNewsletter').click(function () {
  console.log('Button clicked');

  grecaptcha.ready(function() {
      //console.log('reCAPTCHA ready');
      grecaptcha.execute('6LcFZpMqAAAAAA0YLrmL3AxVPYvFAGZzvtaux5iA', {action: 'submit'})
      .then(function(token) {
          if (token) {
              //console.log('Token generated:', token);
              //alert(token);
              $('#formNewsletter').prepend('<input type="hidden" name="token" value="' + token + '">');
              $('#formNewsletter').submit();
          } else {
              //console.error('Token is null');
              //alert('Error: No se pudo generar el token.');
          }
      }).catch(function(error) {
          //console.error('Error in grecaptcha execution:', error);
          //alert('Error al ejecutar reCAPTCHA');
      });
  });
});

$('#formNewsletter').on('submit',function (e) {
  e.preventDefault();
    elementsForm = [
      "mail",
    ];

  contLogin = validationForm(elementsForm,contLogin = 1);
  if(contLogin == 0)
  {
    swal({
      text: "Debes agregar todos los datos requeridos *",
      icon: imageURL,
      button: "OK",
    });
    return false;
  }

  let data = $(this).serialize();

  swal({
    text: "Espera un momento",
    icon: imageURL,
    button: false,
    closeOnClickOutside: false,
  });
  
  $.ajax({
    url: https + "newsletter",
    method: "POST",
    data: data,
    success: function (data) {
      if ($.trim(data) == "1") {
        $("#formNewsletter")[0].reset();
        swal({
          text: "Gracias, por registrarse en nuestro newsletter.",
          icon: imageURL,
          button: "OK",
        });
      }else if ($.trim(data) == "2") {
        swal({
          text: "Error captcha",
          icon: imageURL,
          timer: 3000,
          button: "OK!",
        });
      }else if ($.trim(data) == "3") {
        swal({
          text: "Lo sentimos, este Correo ya se encuentra registrado",
          icon: imageURL,
          button: "OK!",
        });
      }else {
        console.log(data)
        swal({
          text: "Error, ocurrio un problema",
          icon: imageURL,
          timer: 3000,
          button: "OK!",
        });
      }
    }
  });
});
